import React from 'react';
import './loading.css';

const ECS_ICON_URL = 'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/eclipsera-gem.webp';

export const FireLoading: React.FC = React.memo(() => {
    return (
        <div className="game-loading">
            <div className="game-loading-bg" />
            <div className="game-loading-stars">
                {Array.from({ length: 12 }).map((_, i) => (
                    <div key={i} className="game-loading-star" style={{ '--i': i } as React.CSSProperties} />
                ))}
            </div>

            <div className="game-loading-center">
                <div className="game-loading-icon-box">
                    {/* Match the preloading (bootstrap) screen: gem gently floats, no spin, no rings. */}
                    <div className="game-loading-icon-wrap game-loading-icon-wrap--float">
                        <img
                            src={ECS_ICON_URL}
                            alt="Gem"
                            className="game-loading-icon game-loading-icon--static"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
});

FireLoading.displayName = 'FireLoading';
